import React from 'react'
import config from '../index'
import CustomListHeader, { ICustomListHeaderProps } from '../../../__header/customList__header'
import EditableText from 'blocks.simple/editableText/editableText'
import Button from 'blocks.simple/button/button'
import CatalogSelectContent from 'blocks.app/catalog/_select/_content/catalog_select_content'
import helpers from 'core/helpers'
import { api } from 'core/api/ConnectionManager'
import { cn } from 'ethcss'
import translate from 'core/translate'
import grid from 'blocks.simple/grid/grid.jcss'
import listStyles, { mediaPreviewItemStyles } from '../../../__content/customList__content.jcss'

export default {
    ...config,
    category: 'sliderProducts',
    type: 'drinks',
    ...helpers.createListeners({
        category: 'sliderProducts',
        type: 'drinks',
        onCreate: 'burgersProductCreated',
        onUpdate: 'burgersProductUpdated',
        onDelete: 'burgersProductDeleted',
    }),
    headerFilters: (p_: ICustomListHeaderProps) => (
        <CustomListHeader
            {...p_}
            onAdd={() => p_.onAddFakeLine({ title: '' })}
            title={translate('sliderProducts')}
            onDelete={() => {
                const id = p_.selectedItems.map((selectedItem) => selectedItem.id)
                if (id.length > 0) {
                    api.send('deleteBurgersProduct', { id })
                }
                if (p_.fakeLine) {
                    p_.onAddFakeLine(null)
                }
            }}
        />
    ),
    fields: () => [
        { id: 'source', name: translate('image') },
        { id: 'title', name: translate('name') },
        { id: 'volume', name: translate('volumeLabel') },
        { id: 'price', name: translate('price') },
    ],
    list: {
        title: (
            p_: { id: number; title: string },
            active: boolean,
            listProps: {
                fakeLine: {}
                onAddFakeLine: (value?: {}) => void
                template: any
                source: { id: number }
            }
        ) => (
            <EditableText
                id={p_.id}
                text={p_.title}
                onChange={(title: string) => {
                    listProps.onAddFakeLine({ ...listProps.fakeLine, title })
                }}
                onUpdate={(title, cb) => {
                    api.send('updateBurgersProduct', {
                        title,
                        id: p_.id,
                        catalogType: listProps.template.type,
                        categoryName: listProps.template.category,
                        webAppSourceId: listProps.source.id,
                    }).then(cb)
                }}
            />
        ),
        volume: (
            p_: { id: number; volume: number },
            active: boolean,
            listProps: {
                fakeLine: {}
                onAddFakeLine: (value?: {}) => void
                template: any
                source: { id: number }
            }
        ) => (
            <div className={cn(grid.fullWidth, { [grid.row]: !p_.id })}>
                <div className={cn({ [grid.fullWidth]: p_.id, [grid.space]: !p_.id })}>
                    <EditableText
                        id={p_.id}
                        text={p_.volume || ''}
                        type={'number'}
                        placeholder={translate('emptyLabelVolumeError')}
                        disableDefaultFocus={true}
                        onChange={(volume: number) => {
                            listProps.onAddFakeLine({ ...listProps.fakeLine, volume })
                        }}
                        onUpdate={(volume, cb) => {
                            api.send('updateBurgersProduct', {
                                catalogType: listProps.template.type,
                                categoryName: listProps.template.category,
                                webAppSourceId: listProps.source.id,
                                id: p_.id,
                                volume,
                            }).then(cb)
                        }}
                    />
                </div>
            </div>
        ),
        price: (
            p_: { id: number; price: string },
            active: boolean,
            listProps: {
                fakeLine: { source: { id: number }; title: string; price: string }
                onAddFakeLine: (value?: {}) => void
                template: any
                source: { id: number }
            }
        ) => (
            <div className={grid.fullWidth}>
                <div className={grid.fullWidth}>
                    <EditableText
                        id={p_.id}
                        text={p_.price || ''}
                        type={'text'}
                        placeholder={translate('emptyLabelPriceError')}
                        disableDefaultFocus={true}
                        onChange={(price: string) => {
                            listProps.onAddFakeLine({ ...listProps.fakeLine, price })
                        }}
                        onUpdate={(price, cb) => {
                            api.send('updateBurgersProduct', {
                                catalogType: listProps.template.type,
                                categoryName: listProps.template.category,
                                webAppSourceId: listProps.source.id,
                                id: p_.id,
                                price,
                            }).then(cb)
                        }}
                    />
                </div>
                {!p_.id && (
                    <div className={cn(grid.fullWidth, grid.pt_mini, grid.rowCenter)}>
                        <Button
                            className={cn(grid.ml_micro, grid.mr_mini)}
                            indentSize={'mini'}
                            textSize={'mini'}
                            rounded={'full_normal'}
                            onClick={function () {
                                listProps.onAddFakeLine()
                            }}
                        >
                            {translate('cancel')}
                        </Button>
                        <Button
                            mod={'fill'}
                            indentSize={'mini'}
                            textSize={'mini'}
                            rounded={'full_normal'}
                            onClick={function () {
                                api.send('createBurgersProduct', {
                                    catalogType: listProps.template.type,
                                    categoryName: listProps.template.category,
                                    sourceId: listProps.fakeLine.source.id,
                                    webAppSourceId: listProps.source.id,
                                    ...listProps.fakeLine,
                                })
                            }}
                            disabled={
                                !listProps.fakeLine.source || !listProps.fakeLine.title || !listProps.fakeLine.price
                            }
                        >
                            {translate('save')}
                        </Button>
                    </div>
                )}
            </div>
        ),
        source: (
            p_: { id: number; source: { id: number } },
            active: boolean,
            listProps: {
                fakeLine: { source: { id: number } }
                onAddFakeLine: (value?: {}) => void
                template: any
                source: { id: number }
            }
        ) => (
            <div className={cn(grid.fullWidth, grid.colCenter)}>
                <div className={p_.source ? listStyles.mediaPreviewFilled : undefined}>
                    <CatalogSelectContent
                        type={'media'}
                        selectedInfo={p_.source}
                        selectedItemStyles={p_.source ? mediaPreviewItemStyles : undefined}
                        onSelect={(selectedMedia: { id: number }) => {
                            if (p_.id) {
                                api.send('updateBurgersProduct', {
                                    catalogType: listProps.template.type,
                                    categoryName: listProps.template.category,
                                    webAppSourceId: listProps.source.id,
                                    id: p_.id,
                                    sourceId: selectedMedia.id,
                                })
                            } else {
                                listProps.onAddFakeLine({ ...listProps.fakeLine, source: selectedMedia })
                            }
                        }}
                    />
                </div>
            </div>
        ),
    },
    fixedColWidth: true,
}
